export const AUTH = "AUTH";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const LOGOUT = "LOGOUT";

export const GET_POSTS = "GET_POSTS";
export const GET_SINGLE_POST_SUCCESS = "GET_SINGLE_POST_SUCCESS";
export const GET_POSTS_SUCCESS = "GET_POSTS_SUCCESS";
export const CREATE_POST = "CREATE_POST";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const COMMENT_SUCCESS = "COMMENT_SUCCESS";
export const UPDATE_FAIL = "UPDATE_FAIL";
export const DELETE_SUCCESS = "DELETE_SUCCESS";
